import { FC } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { GraduationCap } from 'lucide-react';

import { Button } from '@new/common/ui/Button/Button';

import { TRANSCRIPTS_ROUTE } from '../../lib/routes';

export const CompleteWizardPrompt: FC = () => {
  const navigate = useNavigate();
  const onAddInformation = () => navigate({ to: TRANSCRIPTS_ROUTE });

  return (
    <div className="mx-auto flex w-full max-w-xl flex-col items-center gap-6 px-4 py-10 text-center sm:py-16">
      <span className="flex size-14 items-center justify-center rounded-xl bg-(--primary-O200)">
        <GraduationCap className="size-7 text-(--primary-O1000)" />
      </span>
      <div className="flex flex-col gap-2">
        <h2 className="m-0! [font-family:var(--font-arvo)]! [font-size:var(--fs-h5)]! font-bold text-(--neutral-black-NB900)!">
          Tell us about your studies first
        </h2>
        <p className="m-0! [font-size:var(--fs-b4)]! text-(--neutral-black-NB600)!">
          To build your course plan, we need a few details about your education and the credits you
          already have.
        </p>
      </div>

      <Button
        variant="primary"
        className="w-full sm:w-auto"
        text="Add my information"
        onClick={onAddInformation}
      />
    </div>
  );
};
